<template>
    <div class="grid">
        <div class="col-3 text-center">
            <h4>Ordenes por cliente</h4>
            <Chart type="pie" :data="clientData" :options="orderXCliente" />
        </div>
        <div class="col-4 text-center">
            <h4>Horas de operarios</h4>
            <Chart type="bar" :data="operatorsData" :options="lightOptions" />
        </div>
        <div class="col-4 text-center">
            <h4>Facturación por cliente</h4>
            <Chart type="bar" :data="clientData2" :options="clientData2Options" />
        </div>
        
    </div>
</template>

<script>
import CrudService from "../../services/crud.service";

export default {


    data() {
        return {
                clients: null,
                operators: null,
            clientData: {
                labels: ['Cliente 1','Cliente 2','Cliente 3',],
                datasets: [
                    {
                        data: [300, 50, 100, 243],
                        backgroundColor: ["#42A5F5","#66BB6A","#FFA726","#FF7043"],
                        hoverBackgroundColor: ["#64B5F6","#81C784","#FFB74D","#FF8A65"]
                    }
                ]
            },
            clientData2: {
                labels: ['Cliente 1','Cliente 2','Cliente 3', 'Cliente 4', 'Cliente 5', 'Cliente 6', 'Cliente 7', 'Cliente 8', 'Cliente 9', 'Cliente 10'],
                datasets: [
                    {
                        data: [500000,250000,120000,480000,900000,760000,420000,250000,120000,480000],
                        backgroundColor: ["#66BB6A"],
                        hoverBackgroundColor: ["#64B5F6"]
                    }
                ]
            },
            operatorsData: {
                labels: ['Operario 1', 'Operario 2', 'Operario 3', 'Operario 4', 'Operario 5', 'Operario 6', 'Operario 7'],
                datasets: [{
                    type: 'bar',
                    label: 'Produciendo',
                    backgroundColor: '#66BB6A',
                    data: [50,25,12,48,90,76, 54]
                }, {
                    type: 'bar',
                    label: 'Pausado',
                    backgroundColor: '#FFA726',
                    data: [21,84,24,75,37,65, 14]
                }]
            },
            lightOptions: {
                scales: {
                y: {
                    ticks: {
                        // Include a dollar sign in the ticks
                        callback: function(value, index, ticks) {
                            return  value + " Hs.";
                        }
                    }
                }
            },
            plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                }
            },
            orderXCliente: {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                }
            },
            clientData2Options: {
                scales: {
            y: {
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value, index, ticks) {
                        return  "$ " + value;
                    }
                }
            }
        },
                plugins: {
                    legend: {
        display: false
    },
    tooltips: {
        callbacks: {
           label: function(tooltipItem) {
                  return tooltipItem.yLabel;
           }
        }
    }
                }
            }
        }


    },
    mounted(){
        let names = [];
        let names2 = [];

        let operarios = [];

        CrudService.getCRUD('cliente').then(
        (data) => (this.clients = data)
        )
        .then(
        (data) => {
            for(let i = 0; i < 4; i++){
               names.push(this.clients[i].name);
            }
            for(let i = 0; i < 7; i++){
               names2.push(this.clients[i].name);
            }
            this.clientData.labels = names;
            this.clientData2.labels = names2;
        }
        );

        CrudService.getCRUD('usuario', 'usuario', 'operarios').then(
        (data) => (this.operators = data)
        ).then(
        (data) => {
            for(let i = 0; i < this.operators.length; i++){ 
                operarios.push(this.operators[i].name + " " + this.operators[i].last_name);
            }
                    this.operatorsData.labels = operarios;

        }
        );





    },
}
</script>